
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Whitepaper from './Components/Whitepaper/Whitepaper';
import HowToBuy from './Components/HowToBuy/HowToBuy';
import FAQ from './Components/FAQ/FAQ';
// import Header from './Components/Header/Header';
import Landing from './Components/Landing/Landing';
import Rocket_turtle from './Components/Rocket_turtle/Rocket_turtle';
import Tokenomics from './Components/Tokenomics/Tokenomics';
import Our_Features from './Components/Our_Features/Our_Features';
import Footer from './Components/Footer/Footer';
import RoadMap from './Components/RoadMap/RoadMap';
import Refferal_box from './Components/Refferal_box/Refferal_box';
import { Toaster } from 'react-hot-toast';
import Header from './Components/Header/Header';

function App() {
  return (
    <div className="App">
    <Header/>
    <Toaster />

    <Landing/>
   
    <Rocket_turtle/>
     <RoadMap/>
    <Tokenomics/>
    <Our_Features/>
    <Whitepaper/>
    <HowToBuy/>
    <FAQ/>
       <Footer/>

    </div>
  );
}

export default App;
